import { ISectionState, ISetSectionAction } from "./types";
import ActionTypes from '../../../constants/ActionTypes';

const initialState: ISectionState = {
  section: 'consumer',
};
const sectionReducer = (
  state = initialState,
  action: ISetSectionAction,
): ISectionState => {
  switch (action.type) {
  case ActionTypes.SECTION.SET:
    return {
      ...state,
      section: action.payload.section,
    };
  }
  return state;
};

export default sectionReducer;
